import { Record } from "immutable"

import { updateCreateModel } from "../model-utils"

const dateFields = [
    "create_start_date",
    "create_end_date",
    "updated_start_date",
    "updated_end_date"
]
const tagFields = [
    "topics",
    "dimensions",
    "projects",
    "communities",
    "parents",
    "sub_communities",
    "sub_groups",
    "labels",
    "system_labels",
    "creators",
    "updated_by",
    "users"
]

export const CommunityFilterModel = new Record({
    name: "",
    privacy: "",
    source: "",
    status: "",
    labels: [],
    system_labels: [],
    parents: [],
    sub_groups: [],
    sub_communities: [],
    topics: [],
    dimensions: [],
    projects: [],
    communities: [],
    users: [],
    creators: [],
    updated_by: [],
    create_start_date: null,
    create_end_date: null,
    updated_start_date: null,
    updated_end_date: null
})

export const updateCommunitySearchFilterModel = (
    name,
    value,
    searchFilterModel,
    workingFilterModel
) =>
    updateCreateModel(
        name,
        value,
        searchFilterModel,
        workingFilterModel,
        tagFields,
        dateFields
    )
